<template>
  <div class="Child">
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button type="primary" @click="funcFilter">查询</el-button>
        <el-button type="primary" @click="submitFunc">确定</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="selectDriverTable"
      border
      resizable
      height="500"
      :data="tableData"
      :radio-config="{ highlight: true }"
      :loading="loading"
      @cell-click="cellClickEvent"
      @radio-change="radioChangeEvent"
    >
      <vxe-table-column type="radio" width="60" />
      <vxe-table-column>
        <vxe-table-column field="name" title="实际承运人姓名" min-width="130" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="实际承运人手机号"
          min-width="130"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="实际承运人手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="linkMan" title="车队名称" min-width="130" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.linkMan"
            placeholder="车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadStatusName"
          title="负载状态"
          min-width="130"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleLoadStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车牌号"
          min-width="130"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleOutsideDimensions"
          title="外廓尺寸(mm)"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleOutsideDimensions"
            placeholder="外廓尺寸"
            clearable
            disabled
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="vehicleLoadWeightName"
        title="载重"
        min-width="150"
      />
      <vxe-table-column>
        <vxe-table-column
          field="vehicleClassificationName"
          title="车型"
          min-width="150"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleClassificationCode"
            placeholder="请选择车辆类型"
            clearable
            filterable
          >
            <el-option
              v-for="item in vehicleClassificationList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import request from "@/utils/request";
import { getListDict } from "@/api/commonApi";
export default {
  name: "Child",
  data() {
    return {
      loading: false,
      url: "",
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        isFreeze: "0",
        authStatus: "3",
        driverType: "",
        isTeamSendDetail: "",
        name: "",
        phone: "",
        headImg: "",
        linkMan: "",
        vehicleLicenseNumber: "",
        vehicleLength: "",
        vehicleClassificationName: "",
        vehicleLoadStatus: "",
        authStatusExt: "",
        branchCodeExt: ""
      },
      Pagingconf: [],
      selectRecords: [],
      vehicleClassificationList: [],
      options: [
        {
          value: "0",
          label: "空载"
        },
        {
          value: "1",
          label: "负载"
        }
      ]
    };
  },
  created() {
    getListDict({
      types: "vehicleClassification"
    }).then(response => {
      this.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
    });
  },
  methods: {
    close() {
      this.listQuery = {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        isFreeze: "0",
        authStatus: "3",
        driverType: "",
        isTeamSendDetail: "",
        name: "",
        phone: "",
        headImg: "",
        linkMan: "",
        vehicleLicenseNumber: "",
        vehicleLength: "",
        vehicleClassificationName: "",
        vehicleLoadStatus: "",
        authStatusExt: "",
        branchCodeExt: ""
      };
    },
    init(params) {
      if (params.url) {
        this.url = params.url;
      } else {
        this.$message({ message: "未传递访问接口！", type: "error" });
        this.$emit("fatherCancelMethod");
      }
      if (params.isTeamSendDetail) {
        this.listQuery.isTeamSendDetail = params.isTeamSendDetail;
      }
      if (params.driverType) {
        this.listQuery.driverType = params.driverType;
      }
      if (params.authStatusExt) {
        this.listQuery.authStatusExt = params.authStatusExt;
      }
      if (params.branchCodeExt) {
        this.listQuery.branchCodeExt = params.branchCodeExt;
      }
      this.findList();
    },
    findList() {
      this.loading = true;
      request({
        url: `/ntocc-basic-api/${this.url}`,
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.loading = false;
      });
    },
    cellClickEvent() {},
    radioChangeEvent({ checked, row }) {},
    submitFunc() {
      const row = this.$refs.selectDriverTable.getRadioRecord();
      this.$emit("fatherSubmitMethod", {
        driverCode: row.partyCode,
        name: row.name,
        vehicleCode: row.vehicleCode,
        teamCode: row.teamCode ? row.teamCode : "" // 车队code
      });
    }
  }
};
</script>

<style></style>
